module.exports = __webpack_public_path__ + "img/logo.088810f8.jpg";